module.exports = __webpack_public_path__ + "img/eat_out_04.4e79c590.jpg";